/**
 * Makes a horizontally scrollable table announce that it scrolls.
 *
 * Hidden horizontal scroll is easy to miss: on a phone the scrollbar is
 * invisible until you already touch the right place, so a table can look
 * complete when half its columns are off screen.
 *
 * Two signals, which work together:
 *   - a fade at whichever edge has more content, so the direction is visible
 *   - a standing "swipe" hint, shown whenever the table can scroll
 *
 * Both are driven by actual scroll position, so they disappear when there is
 * nothing more to see rather than lingering and crying wolf.
 */
(function () {
  const WRAPPER = '[data-scroll-hint]';

  function update(wrapper) {
    const max = wrapper.scrollWidth - wrapper.clientWidth;
    // A pixel of slack: sub-pixel widths otherwise leave a fade stuck on.
    const scrollable = max > 1;

    wrapper.classList.toggle('is-scrollable', scrollable);
    wrapper.classList.toggle('has-overflow-start', scrollable && wrapper.scrollLeft > 1);
    wrapper.classList.toggle('has-overflow-end', scrollable && wrapper.scrollLeft < max - 1);

  }

  function observe(wrapper) {
    let frame = null;
    const schedule = () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        frame = null;
        update(wrapper);
      });
    };

    schedule();
    wrapper.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);

    // Catches a table whose contents change -- a variant swap, say.
    if ('ResizeObserver' in window) {
      new ResizeObserver(schedule).observe(wrapper);
    }
  }

  function init() {
    document.querySelectorAll(WRAPPER).forEach(observe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // Tables swapped in on variant change arrive after init.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      requestAnimationFrame(init);
    });
  }
})();
